export const IS_CUSTOMER_KEY = "isCustomer";

export const isCustomerUser = () =>
  localStorage.getItem(IS_CUSTOMER_KEY) === "true";

export const setIsCustomer = (isCustomer: boolean) => {
  localStorage.setItem(IS_CUSTOMER_KEY, isCustomer.toString());
};

export const clearAuthStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expiration");
  localStorage.removeItem(IS_CUSTOMER_KEY);
};

export const checkTokenValidation = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  const expDateStr = localStorage.getItem("expiration");
  if (!expDateStr) return false;
  const expDate = new Date(expDateStr);
  const currDate = new Date();
  if (expDate > currDate) return true;
  return false;
};

export const getDeltaTInMinOptions = () => {
  return [
    { id: 60, name: "یک ساعت" },
    { id: 240, name: "4 ساعت" },
    { id: 720, name: "12 ساعت" },
    { id: 1440, name: "یک روز" },
  ];
};

export type InputTypes =
  | "price"
  | "priceWithDecimal"
  | "number"
  | "pan"
  | "percent"
  | "negativeNumbers"
  | "negativeDecimalNumbers";
export const addSeperatorToInput = (input: any, kind?: InputTypes) => {
  if (!input) return null;

  switch (kind) {
    case "number":
    case "price":
      return printPrice(input);

    case "priceWithDecimal":
      return printPriceWithDecimals(input);

    case "negativeDecimalNumbers":
      return printPriceWithDecimals(input, Infinity);

    case "pan":
      return printPan(input);

    default:
      return input;
  }
};

export function printPrice(x: any) {
  if (typeof x == "undefined") return null;

  if (x === null || x === "") return null;

  x = fixNumbers(x);
  // x = removeNonNumber(x);
  x = parseInt(x);

  if (isNaN(x)) return null;

  return MytoLocaleString(x);
}

export function printPriceWithDecimals(x: any, decimalPlaces = 2) {
  const input = x?.toString();

  if (!input) return null;
  const negativeFlag = input[0] === "-";
  const priceParts = input.slice(negativeFlag ? 1 : 0).split(".");
  if (priceParts.length > 1)
    return `${negativeFlag ? "-" : ""}${
      printPrice(priceParts[0]) || ""
    }.${priceParts[1].substring(0, decimalPlaces)}`;
  return `${negativeFlag ? "-" : ""}${printPrice(priceParts[0]) || ""}`;
}

export function printOrderBookTableCell(x: any) {
  if (!x) return "-";
  return printPriceWithDecimalsForTableCell(x);
}

export function printPriceWithDecimalsForTableCell(x: any) {
  const input = x?.toString();

  if (!input) return "-";
  const negativeFlag = input[0] === "-";
  const priceParts = input.slice(negativeFlag ? 1 : 0).split(".");
  if (Math.abs(parseInt(input)) < 1000) {
    if (priceParts.length > 1)
      return `${negativeFlag ? "-" : ""}${
        printPrice(priceParts[0]) || ""
      }.${priceParts[1].substring(0, 2)}`;
    return `${negativeFlag ? "-" : ""}${printPrice(priceParts[0]) || ""}`;
  }
  return `${negativeFlag ? "-" : ""}${printPrice(priceParts[0]) || ""}`;
}

export function printPan(x: any) {
  if (typeof x === "undefined") return null;

  if (x === null || x === "") return null;

  x = fixNumbers(x);
  x = removeNonNumber(x);

  if (isNaN(x)) return "0";

  return addDashToPanCard(x);
}

export function fixNumbers(str: any) {
  var persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  var arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
}

export function removeNonNumber(str: string) {
  if (typeof str === "string") {
    str = str.replace(/[^\x30-\x39]/g, "");
  }
  return str;
}

export function addDashToPanCard(value: string) {
  // return value.replace(/[^0-9]/g, "").replace(/\W/gi, '').replace(/(.{4})/g, '$1-');

  var result = "";

  for (var i = 0; i < value.length; i++) {
    if (i >= 16) break;

    if (i % 4 === 0 && i > 0) result = result + "-";

    result = result + value.charAt(i);
  }

  return result;
}

export function MytoLocaleString(s: any) {
  let s1 = s.toLocaleString();
  const p = new Number(Math.floor(s) + 0.1); // similar value but decimal
  const p1 = p.toLocaleString();
  let index;
  let point;
  for (index = p1.length - 1; index > 0; index--) {
    // find decimal point in dummy
    point = p1.charAt(index);
    if (point < "0" || point > "9") break;
  }
  if (index > 0) {
    index = s1.lastIndexOf(point); // find last point in string
    if (index > 0) s1 = s1.slice(0, index); // truncate decimal part

    return s1;
  }
  return "";
}

export function getPan(x: any) {
  if (!x) return null;

  x = fixNumbers(x);
  x = removeNonNumber(x);

  return x;
}

export function getPrice(x: any): number | null {
  if (!x) return null;

  x = fixNumbers(x);
  x = removeNonNumber(x);

  x = parseInt(x);

  return x;
}

export function getPriceWithDecimals(x: any): number | null {
  if (!x) return null;

  x = fixNumbers(x);
  x = removeNonNumber(x);

  x = parseFloat(x);

  return x;
}

export const checkForDecimalNumbers = (v: string) => {
  // Remove commas from the input
  const rawV = v.split(",").join("");
  // Check if the original string contains a dot
  const dotFlag = v.includes(".");
  // Split the raw value by dot and filter out empty parts
  const parts = rawV.split(".").filter((p) => p !== "");

  // Define a regex for valid numbers with optional leading negative sign and decimal point
  const decimalRegex: RegExp = /^-?\d+(\.\d+)?$/;

  if (parts.length === 1) {
    if (decimalRegex.test(parts[0])) {
      return !dotFlag
        ? parts[0][0] === "-"
          ? "-" + parseFloat(parts[0])
          : parseFloat(parts[0])
        : `${parts[0]}.`;
    }
  } else if (parts.length === 2) {
    const combined = parts[0] + "." + parts[1];
    if (decimalRegex.test(combined)) {
      // Return as a string to maintain trailing zeroes
      return combined;
    }
  }

  return null;
};

export const getPercent = (x: string) => {
  const percentRegex: RegExp = /^(100(\.0+)?|0|[1-9]?\d(\.\d+)?)$|^\d+\.$/;

  if (percentRegex.test(x)) return x;

  return null;
};

export const getUnboundedPercent = (x: string) => {
  const percentRegex: RegExp = /^(?:0|[1-9]\d*)(?:\.\d*)?$/;

  if (percentRegex.test(x)) return x;

  return null;
};

export const getNegativeNumber = (v: string) => {
  const regex: RegExp = /^-?\d*$/;
  if (regex.test(v)) return v;
  return null;
};

export const getNegativeWithDecimalsNumber = (v: string) => {
  v = v.replace(/,/g, "");
  const regex: RegExp = /^-?(\d+(\.\d*)?|(\.))?$/;
  if (!v) return null;
  if (regex.test(v)) return v;
  return null;
};

export const incrementSeconds = (time?: string) => {
  //format should be HH:MM:SS
  if (!time) return "";

  const [hour, minute, second] = time.split(":");
  let newSecond = parseInt(second);
  let newMinute = parseInt(minute);
  let newHour = parseInt(hour);

  if (newSecond < 59) newSecond += 1;
  else {
    newSecond = 0;
    if (newMinute < 59) newMinute = newMinute + 1;
    else {
      newMinute = 0;
      if (newHour < 23) newHour = newHour + 1;
      else newHour = 0;
    }
  }
  return `${newHour.toString().padStart(2, "0")}:${newMinute
    .toString()
    .padStart(2, "0")}:${newSecond.toString().padStart(2, "0")}`;
};

export const decrementSeconds = (time: string) => {
  //format should be HH:MM:SS

  const [hour, minute, second] = time.split(":");
  let newSecond = parseInt(second);
  let newMinute = parseInt(minute);
  let newHour = parseInt(hour);

  if (newSecond > 0) newSecond -= 1;
  else {
    newSecond = 59;
    if (newMinute > 0) newMinute -= 1;
    else {
      newMinute = 59;
      if (newHour > 0) newHour -= 1;
      else newHour = 0;
    }
  }

  return `${newHour.toString().padStart(2, "0")}:${newMinute
    .toString()
    .padStart(2, "0")}:${newSecond.toString().padStart(2, "0")}`;
};

export const stringifyNumbers = (number: string | number) => {
  switch (number) {
    case 1:
    case "1":
      return "اول";

    case 2:
    case "2":
      return "دوم";

    case 3:
    case "3":
      return "سوم";

    case 4:
    case "4":
      return "چهارم";

    case 5:
    case "5":
      return "پنجم";

    default:
      return "-";
  }
};

export const addComma = (price: string | number) => {
  if (typeof price === "number") {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else if (typeof price === "string") {
    return price.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return price;
};

export const removeComma = (price: string | number) => {
  if (typeof price === "number") {
    return price.toString().replace(/,/g, "");
  } else if (typeof price === "string") {
    return price.replace(/,/g, "");
  }
  return price;
};
